export class User {
  name: string;
  profile: any;
  lastLogin: string;
  flActive: string;
  language?: number;
}

export class UserUpdate {
  flActive: boolean;
  serviceProviderId: number;
  language?: number;
}
